import { put } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { z } from "zod";
import { useTu } from "@src/appV2/i18n/useTu";

const updateWorkerTypesBodySchema = z.object({
  facilityId: z.string(),
  performedBy: z.string(),
  workerTypePreferences: z.object({
    excluded: z.array(z.string()),
    sortOrder: z.array(z.string()),
  }),
});

export type UpdateWorkerTypesParams = z.infer<typeof updateWorkerTypesBodySchema>;

const updateWorkerTypesResponseSchema = z.object({}).passthrough();

export function useUpdateWorkerTypes() {
  const { tu } = useTu("schedule");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateWorkerTypesParams) => {
      const response = await put({
        url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/facilityprofile/put`,
        data: params,
        bodySchema: updateWorkerTypesBodySchema,
        responseSchema: updateWorkerTypesResponseSchema,
      });

      return response.data;
    },
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: [
          `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/${variables.facilityId}/worker-types`,
        ],
      });
    },
    meta: {
      logErrorMessage: tu("Failed to update worker type visibility"),
    },
  });
}
